<template>
  <div>
    <v-card>
      <v-card-title>
        Import Ip address
        <v-spacer></v-spacer>
        <v-btn icon
        ><v-icon color="dark" @click="cancel">mdi-close</v-icon></v-btn
        >
      </v-card-title>
      <v-divider class="mx-4 mb-2"></v-divider>
      <v-card-text>
        <ValidationObserver ref="observer" v-slot="{ dirty, invalid }">
          <v-row>
            <v-col cols="12" class="my-3 py-0 px-0">
              <v-switch
                v-model="isSingleImport"
                hide-details
                true-value="Import a Single Ip Address"
                false-value="Import Ip Address by Subnet"
                :label="`Switch: ${isSingleImport}`"
              ></v-switch>
              <v-divider class="mx-3"></v-divider>
            </v-col>
            <v-col cols="12" class="my-3 py-0 px-0" v-if="isSingleImport == 'Import a Single Ip Address'">
              <v-text-field
                label="Static IP"
                placeholder=" "
                outlined
                persistent-hint
                v-model="ipAddress"
                autocomplete="off"
                color="dark"
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="my-3 py-0 px-0" v-else>
              <v-text-field
                label="IP Subnet"
                placeholder=" "
                outlined
                persistent-hint
                v-model="subnet"
                autocomplete="off"
                color="dark"
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="my-3 py-0 px-0">
              <v-select
                label="State"
                placeholder="Select State"
                outlined
                clearable
                v-model="state"
                :items="stateOptions"
                item-text="text"
                item-value="value"
                color="dark"
              ></v-select>
            </v-col>
            <v-col cols="12" class="text-right">
              <v-btn
                @click.prevent="triggerConfirm"
                color="dark"
                class="white--text mr-4"
                :disabled="subnet=='' && ipAddress ==''"
              >Save</v-btn
              >
              <v-btn @click="cancel">Cancel</v-btn>
            </v-col>
          </v-row>
        </ValidationObserver>
        <confirm
          :dialog="dialog"
          :text="`You are about to import ip address. Do you want to proceed?`"
          :proceedText="`Yes`"
          :cancelText="`Cancel`"
          @onBtnClick="save"
        ></confirm>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import {JsonParse} from "@/plugins/functions";
import confirm from "@/components/confirm";
import { stateOptions } from "@/config/stateOptions";

export default {
  name: "edit-ip",
  data: () => ({
    isSingleImport: "Import Ip Address by Subnet",
    url: "",
    target: "",
    subnet:"",
    ipAddress:"",
    dialog: false,
    state: 'NSW',
    stateOptions,
  }),
  components: {
    confirm
  },
  beforeMount() {
    let vm = this;
  },
  methods: {
    triggerConfirm(args) {
      let vm = this;

      vm.payload = args;
      vm.dialog = true;
    },
    save(args) {
      let vm = this;
      if(args)
      {
        if(vm.isSingleImport === "Import Ip Address by Subnet")
        {
          vm.importIpAddressesRange({
            subnet: vm.subnet.trim(),
            state: vm.state
          })
            .then((data) => {
              vm.$emit("saved");
            })
            .catch(() => {
            });
        } else if(vm.isSingleImport === "Import a Single Ip Address")
        {
          vm.addSingleIpAddresses({
            ipAddress: vm.ipAddress.trim(),
            state: vm.state
          })
            .then((data) => {
              vm.$emit("saved");
            })
            .catch(() => {
            });
        }
      }

      vm.dialog = false;
    },
    cancel() {
      let vm = this;
      vm.$refs.observer.reset();
      // vm.getService();
      vm.$emit("cancel");
    },
  },
}
</script>

<style scoped>
.btn--save {
  color: #fff;
}

::v-deep .custom-btn {
  height: 105px !important;
  width: 100px;
  overflow: hidden;
}

::v-deep .custom-btn .v-btn__content {
  display: block !important;
  width: 100px;
}

::v-deep .custom-btn .v-btn__content span {
  margin: 10px 0 !important;
  display: block !important;
}

::v-deep .custom-btn .btn-font {
  font-size: 12px;
}
</style>
